import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/SignUpDialog' /* webpackChunkName: "SignUpDialog" */),
    import(
      './viewer/SignUpDialog.controller' /* webpackChunkName: "SignUpDialog" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('SignUpDialog', UiTypes),
};

export default entry;
